module.exports = __webpack_public_path__ + "img/1529499626.32b557e8.jpg";